import { createRouter, createWebHashHistory } from 'vue-router'
import top from './top'
import unit from './unit'
import platform from './platform'
import enterprise from './enterprise'
import carrier from './carrier'

const routes = [
  {
    path:'/',
    redirect: 'home'
  },
  {
    path: '/home',
    name: 'home',
    component: ()=> import('../views/home/home')
  },
  
  ...top,
  ...unit,
  ...platform,
  ...enterprise,
  ...carrier,


  {   // 展示页面
    path: '/OtherShowPage/BusinessVolume',
    name: 'BusinessVolume',
    component: ()=> import('../views/OtherShowPage/BusinessVolume')
  }, 
  {   // 展示页面
    path: '/OtherShowPage/HighAssessData',
    name: 'HighAssessData',
    component: ()=> import('../views/OtherShowPage/HighAssessData')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
